import { render, staticRenderFns } from "./ChatIntroduction.vue?vue&type=template&id=7499e8a3&scoped=true"
var script = {}
import style0 from "./ChatIntroduction.vue?vue&type=style&index=0&id=7499e8a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7499e8a3",
  null
  
)

export default component.exports